module.exports = {
  ALL_REPORTS: 'ALL_REPORTS',
  MY_REPORTS: 'MY_REPORTS',
  APPLICATIONS: 'APPLICATIONS',
};
